import { createApp }       from "vue";
import { createStore }     from "vuex";
import PortalVue           from "portal-vue";
import InstantSearch       from "vue-instantsearch/vue3/es";
import menu                from "../store/modules/menu";
import DesktopMenu         from "../../components/DesktopMenu";
import MobileMenu          from "../../components/MobileMenu";
import ModalVue            from "../../components/ModalVue";
import HeaderNav           from "../../components/HeaderNav";
import HeaderNavCategories from "../../components/HeaderNavCategories";
import AlgoliaSearchInput  from "../../components/Algolia/AlgoliaSearchInput";
import AutoComplete        from "../../components/Algolia/Autocomplete/AutoComplete";
import i18n                from "../translations/i18n";

export const initializeDesktopNavigationApp = () => {
    if (!document.getElementById('js_mainNav')) {
        return;
    }

    const app   = createApp({});
    const store = createStore({
        modules: {
            menu,
        }
    });

    app.use(PortalVue);
    app.use(i18n)
    app.use(InstantSearch);
    app.use(store);

    app.component('desktop-menu', DesktopMenu);
    app.component('modal-vue', ModalVue);
    app.component('header-nav', HeaderNav);
    app.component('header-nav-categories', HeaderNavCategories);
    app.component('algolia-search-input', AlgoliaSearchInput);
    app.component('auto-complete', AutoComplete);

    app.mount('#js_mainNav');
};

export const initializeMobileNavigationApp = () => {
    if (!document.getElementById('mobileMenu')) {
        return;
    }

    const app = createApp({});

    app.use(InstantSearch);

    app.use(i18n);

    app.component('mobile-menu', MobileMenu);

    app.mount('#mobileMenu');
}

export const initializeSubcategoryNavigationApp = () => {
    if (!document.getElementById('js_subcategoryNav')) {
        return;
    }

    const app = createApp({});

    app.use(InstantSearch);

    app.component('header-nav-categories', HeaderNavCategories);

    app.mount('#js_subcategoryNav');
}
